export const handleEnterKeyPress = (event, callback) => {
    if (event.keyCode === 13 || event.code === 'Enter') {
        callback(event);
    }
};
